














































































import { Component, Prop, Vue } from "vue-property-decorator";
import { itemProperties } from "@/data/ItemProperties";
import StringlistProperty from "./StringlistProperty.vue";
import ItemPropertyComponent from "./itemproperties/itemProperty";

const regex = /(.*?):(.*)/;

// TODO: Check why v-checkbox isn't working properly

@Component({
    components: {
        "item-property": ItemPropertyComponent
    }
})
export default class ItemProperty extends Vue {

    @Prop({ type: String })
    name!: string;

    @Prop({ type: Array })
    value!: string[];

    window = 0;
    open = false;

    // for adding a custom property
    text = "";

    // for editing properties
    editingIndex = -1;
    tempValue: any = null;

    availableProperties = itemProperties.values;

    get entries() {
        return this.value ?
            this.value.map((s) => {
                const res = regex.exec(s);
                if (res && res.length === 3) {
                    return [res[2], res[1]];
                } else {
                    return [s, ""];
                }
            }) : [];
    }

    get selectedProperty() {
        if (this.editingIndex >= 0) {
            const propertyName = this.entries[this.editingIndex][1];
            if (propertyName) {
                return this.availableProperties.find((x) => x.key === propertyName);
            }
        }
        return undefined;
    }

    addCustomProperty() {
        const newValue = (this.value || []).concat([this.text]);
        this.$emit("input", newValue);
        this.text = "";
    }

    async addProperty(i: number) {
        const p = this.availableProperties[i];
        const defaultValue = p.content.map((e) => e.default).join("#");
        this.$emit("input", (this.value || []).concat([ `${p.key}:${defaultValue}` ]));
        await this.$nextTick();
        if (this.value && this.value.length) {
            this.edit(this.value.length - 1);
        } else {
            this.window = 0;
        }
    }

    edit(index: number) {
        this.editingIndex = index;
        this.tempValue = this.entries[index][0];
        this.window = 1;
    }

    save() {
        const i = this.editingIndex;
        const copy = this.value.slice(0);
        copy[i] = this.entries[i][1] + ":" + this.tempValue;
        this.$emit("input", copy);
        this.window = 0;
        this.editingIndex = -1;
    }

    remove(index: number) {
        const clonedArray = this.value.slice(0);
        clonedArray.splice(index, 1);
        this.$emit("input", clonedArray);
    }

}
